// extracted by mini-css-extract-plugin
export default {"button":"HFeQ","caption":"e2J2","tooltipTitle":"Ogpg"};